import Hardware from 'src/models/hardware/Hardware'
import KitchenDisplay from 'src/models/kitchen-display/KitchenDisplay'
import Model, { encoders, ID, MODEL_LEVEL } from 'src/models/model'
import Librariable from 'src/models/model/concerns/Librariable'
import RegisterStation from 'src/models/register/RegisterStation'
import Site from 'src/models/site/Site'

export const PRINTER_SOURCE_TYPES = {
  HARDWARE: 'hardware',
  KITCHEN_DISPLAY: 'kitchen_display',
  REGISTER: 'register'
}
PRINTER_SOURCE_TYPES.ALL = _.values(PRINTER_SOURCE_TYPES)

export default class LocationGroup extends Model {
  static name = 'LocationGroup'

  static deletable = true
  static duplicatable = true
  static paginate = true
  static isConfiguration = true

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Kitchen, Model.permissionCategories.Concession, Model.permissionCategories.PointOfSale, Model.permissionCategories.HardwareAndRegisterStation]
  static manageAction = ['Manage', 'ManagePrinterRouting']

  static define () {
    this.concerns = [Librariable]

    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      site: {
        type: Site,
        default: null,
        reference: true,
        output: true
      },
      printerSource: {
        type: String,
        default: PRINTER_SOURCE_TYPES.HARDWARE
      },
      printer: {
        type: Hardware,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },
      registerStation: {
        type: RegisterStation,
        default: null,
        encode: encoders.hasOne,
        reference: true
      },
      kitchenDisplay: {
        type: KitchenDisplay,
        default: null,
        encode: encoders.hasOne,
        reference: true
      }
    }

    this.computed = {
      resolvedPrinter () {
        if (this.printerSource === PRINTER_SOURCE_TYPES.HARDWARE) {
          return this.printer
        } else if (this.printerSource === PRINTER_SOURCE_TYPES.REGISTER) {
          return this.registerStation
        } else if (this.printerSource === PRINTER_SOURCE_TYPES.KITCHEN_DISPLAY) {
          return this.kitchenDisplay
        } else {
          return null
        }
      }
    }
  }
}
